import { useEffect, useState } from 'react';
import Heading from '../../components/Heading/Heading';
import NavBar from '../../components/NavBar/NavBar';
import { dashboard } from '../../api/apiHandler';

export default function Dashboard({ isLoader }) {
    const [dashboardData, setDashboardData] = useState(null);
    const donor_id = localStorage.getItem("DAid");
    useEffect(() => {
        dashboardAPI()
    }, [])
    const dashboardAPI = async () => {
        const res = await dashboard({donor_id : donor_id});
        if (res.data.code == 1) {
            setDashboardData(res.data.data);
        } else {
            setDashboardData(null);
        }
    }

    return (
        <>
            <NavBar />
            <section className="content home">
                <Heading title="Dashboard" />
                <div className="container-fluid">
                    {dashboardData ? (
                        <div className="row clearfix social-widget">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-6">
                                <div className="card info-box-2 hover-zoom-effect facebook-widget">
                                    <div className="icon"><i className="zmdi zmdi-balance-wallet"></i></div>
                                    <div className="content">
                                        <div className="text">Total Amount</div>
                                        <div className="number">{dashboardData?.wallet_balance || 0}</div>
                                    </div>
                                </div>
                            </div>
                            {/* Other widgets */}
                        </div>
                    ) : (
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="body">
                                        <p>No dashboard data available.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}
